/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { styles } from '../AxisStyles.css';
import { baseTheme } from './AxisBaseTheme.css';
import { multiVariantStyles } from './AxisVariants.css';

const AxisStableTheme = {
  multiVariantStyles,
  baseTheme,
  styles
};

export { AxisStableTheme };
